export const FETCH_BRANDS = 'FETCH_BRANDS';
export const DONE_FETCHING_BRANDS = 'DONE_FETCHING_BRANDS';
export const ERROR_FETCHING_BRANDS = 'ERROR_FETCHING_BRANDS';

export const FETCH_BRAND = 'FETCH_BRAND';
export const DONE_FETCHING_BRAND = 'DONE_FETCHING_BRAND';
export const ERROR_FETCHING_BRAND = 'ERROR_FETCHING_BRAND';

export const FETCH_BRAND_FEEDBACK = 'FETCH_BRAND_FEEDBACK';
export const DONE_FETCHING_BRAND_FEEDBACK = 'DONE_FETCHING_BRAND_FEEDBACK';
export const ERROR_FETCHING_BRAND_FEEDBACK = 'ERROR_FETCHING_BRAND_FEEDBACK';

export const CREATE_BRAND = 'CREATE_BRAND';
export const DONE_CREATING_BRAND = 'DONE_CREATING_BRAND';
export const ERROR_CREATING_BRAND = 'ERROR_CREATING_BRAND';

export const UPDATE_BRAND = 'UPDATE_BRAND';
export const DONE_UPDATING_BRAND = 'DONE_UPDATING_BRAND';
export const ERROR_UPDATING_BRAND = 'ERROR_UPDATING_BRAND';

export const UPDATE_AND_REVET_BRAND = 'UPDATE_AND_REVET_BRAND';
export const DONE_UPDATING_AND_REVETIING_BRAND = 'DONE_UPDATING_AND_REVETIING_BRAND';
export const ERROR_UPDATING_AND_REVETTING_BRAND = 'ERROR_UPDATING_AND_REVETTING_BRAND';

export const DEACTIVATE_BRAND = 'DEACTIVATE_BRAND';
export const DONE_DEACTIVATING_BRAND = 'DONE_DEACTIVATING_BRAND';
export const ERROR_DEACTIVATING_BRAND = 'ERROR_DEACTIVATING_BRAND';

export const REMOVE_DEACTIVATION_ERROR = 'REMOVE_DEACTIVATION_ERROR';
export const REMOVE_UPDATE_ERROR = 'REMOVE_UPDATE_ERROR';
export const REMOVE_LAST_CREATED_BRAND = 'REMOVE_LAST_CREATED_BRAND';
export const REMOVE_LAST_DEACTIVATED_BRAND = 'REMOVE_LAST_DEACTIVATED_BRAND';
export const REMOVE_CREATION_ERRORS = 'REMOVE_CREATION_ERRORS';
export const CHANGE_BRANDS_LIST_VIEW = 'CHANGE_BRANDS_LIST_VIEW';
